// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"Modal_maxWidth__H8A85"};